import type { paths } from './api'
import createClient from 'openapi-fetch'
import { getApiBase } from '~/utils/api-base'
import { noteRequest } from '~/utils/admin-counts'

const client = createClient<paths>({ baseUrl: getApiBase() + '/' })

// Successful writes on admin screens refresh the sidebar row counters.
// Registered first = its onResponse runs last (openapi-fetch runs onResponse
// in reverse order), so it sees the response after the auth store's
// refresh-and-retry middleware.
client.use({
  onResponse({ request, response }) {
    noteRequest(request.method, request.url, response.ok)
    return response
  },
})

export default client
